export default __webpack_public_path__ + "static/media/placeholder-portrait.ef27cddc.svg";